import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IPager } from './interfaces/i-pager';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pager',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss'],
})
export class PagerComponent implements OnInit, OnChanges {
  @Input() pager!: IPager;
  @Input() totalCount!: number;
  @Input() dialogHeight: boolean = false;
  @Output() handlePageChange = new EventEmitter<number>();
  @Output() handlePageSizeChange = new EventEmitter<number>();

  pageNumbers = [];
  activePageSizeForm = this.formBuilder.control(12);

  Math = Math;
  private PAGES_QTY_TO_SHOW = 5;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this._populatePageButtonArray();
    this._updateCurrentPageSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pager || changes.totalCount) {
      this._populatePageButtonArray();
      this._updateCurrentPageSize(changes.pager?.currentValue?.currentPageSize);
    }
  }

  private _updateCurrentPageSize(pageSize = this.pager.currentPageSize): void {
    this.activePageSizeForm.setValue(pageSize);
  }

  private _populatePageButtonArray(): void {
    this.pageNumbers = [];

    if (this.totalCount === 0) {
      return;
    }

    const maxPage = Math.ceil(this.totalCount / this.pager.currentPageSize);
    const { currentPage: currentPageIndex } = this.pager;
    const start = currentPageIndex - 3 <= 0 ? 1 : currentPageIndex - 2;
    let end = start + (this.PAGES_QTY_TO_SHOW - 1);

    if (start + (this.PAGES_QTY_TO_SHOW - 1) > maxPage) {
      end = maxPage;
    }

    for (let i = start; i <= end; i++) {
      this.pageNumbers.push(i);
    }
  }

  isActivePage(currentPage: number): boolean {
    return this.pager.currentPage === currentPage;
  }
}
